import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import YourselfPage from './pages/YourselfPage';
import EarthPage from './pages/EarthPage';
import StocksPage from './pages/StocksPage';
import GenerosityPage from './pages/GenerosityPage';
import BlogDetail from './pages/BlogDetail';
import VideosPage from './pages/VideosPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<><Navbar /><HomePage /></>} />
          <Route path="/yourself" element={<><Navbar /><YourselfPage /></>} />
          <Route path="/earth" element={<><Navbar /><EarthPage /></>} />
          <Route path="/stocks" element={<><Navbar /><StocksPage /></>} />
          <Route path="/generosity" element={<><Navbar /><GenerosityPage /></>} />
          <Route path="/blog/:id" element={<><Navbar /><BlogDetail /></>} />
          <Route path="/videos" element={<><Navbar /><VideosPage /></>} />
          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/*" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
